jQuery(document).ready(function ($) {
  const segmentSelectorMap = [
    ["[id='Path_49719']", "[id='Ellipse_152']"],
    ["[id='Path_49722']", "[id='Ellipse_153']"],
    ["[id='Rectangle_22275']", "[id='Ellipse_155']"],
    ["[id='Path_49720']", "[id='Ellipse_154']"],
  ];

  $(".int-accordion").each(function () {
    const $block = $(this);
    const $items = $block.find(".int-accordion__item");
    const $headers = $block.find(".int-accordion__item-header");
    const $panels = $block.find(".int-accordion__item-panel");
    const $icons = $block.find(".int-accordion__icon");
    const $center = $block.find(".int-accordion__center");
    const $centerMedia = $block.find(".int-accordion__center-media");
    const $centerNumber = $block.find(".int-accordion__center-number");
    const $centerTitle = $block.find(".int-accordion__center-title");
    const $svg = $block.find(".int-accordion__illustration-svg svg").first();

    const itemCount = $items.length;
    const segmentGroups = [];

    if (!itemCount) {
      return;
    }

    if ($svg.length) {
      segmentSelectorMap.forEach((selectorGroup, index) => {
        let $segment = $();

        selectorGroup.forEach((selector) => {
          $segment = $segment.add($svg.find(selector));
        });

        if ($segment.length) {
          $segment
            .addClass("int-accordion__svg-click-target")
            .attr("data-index", index)
            .attr("tabindex", 0)
            .attr("role", "button")
            .attr("aria-label", "Show item " + (index + 1));

          segmentGroups[index] = $segment;
        }
      });
    }

    let activeIndex = parseInt($block.attr("data-active-index"), 10);
    if (Number.isNaN(activeIndex) || activeIndex < 0 || activeIndex >= itemCount) {
      activeIndex = 0;
    }
    let currentRotation = activeIndex * -90;
    let centerFadeTimeout = null;

    const applyCenterContent = ($item, index) => {
      if (!$center.length) {
        return;
      }

      const fallbackNumber = String(index + 1).padStart(2, "0");
      const number = $item.attr("data-center-number") || fallbackNumber;
      const title =
        $item.attr("data-center-title") ||
        $item.find(".int-accordion__item-title").text().trim();
      const background = $item.attr("data-center-bg") || "";

      $centerNumber.text(number);
      $centerTitle.text(title);

      if (background) {
        const escapedBackground = background.replace(/"/g, '\\"');
        $centerMedia.css("background-image", 'url("' + escapedBackground + '")');
        $center.addClass("has-image");
      } else {
        $centerMedia.css("background-image", "none");
        $center.removeClass("has-image");
      }
    };

    const updateCenterContent = ($item, index, animate = true) => {
      if (!$center.length) {
        return;
      }

      if (centerFadeTimeout) {
        window.clearTimeout(centerFadeTimeout);
        centerFadeTimeout = null;
      }

      if (!animate) {
        $center.removeClass("is-fading");
        applyCenterContent($item, index);
        return;
      }

      $center.addClass("is-fading");
      centerFadeTimeout = window.setTimeout(() => {
        applyCenterContent($item, index);
        $center.removeClass("is-fading");
        centerFadeTimeout = null;
      }, 160);
    };

    const setActive = (rawIndex, animate = true) => {
      const nextIndex = ((rawIndex % itemCount) + itemCount) % itemCount;
      const animationDuration = animate ? 320 : 0;
      let rotation = currentRotation;

      if (!animate) {
        rotation = nextIndex * -90;
      } else if (nextIndex !== activeIndex) {
        // Keep motion consistently anticlockwise.
        const clockwiseSteps = (nextIndex - activeIndex + itemCount) % itemCount;
        rotation = currentRotation - clockwiseSteps * 90;
      }

      $block.attr("data-active-index", nextIndex);
      $block[0].style.setProperty("--rotation", rotation + "deg");
      $block[0].style.setProperty("--counter-rotation", rotation * -1 + "deg");

      $items.removeClass("is-active");
      $headers.attr("aria-expanded", "false");
      $icons.removeClass("is-active");
      $panels.stop(true, true);

      segmentGroups.forEach(($segment, index) => {
        if (!$segment || !$segment.length) {
          return;
        }

        const isActive = index === nextIndex;
        $segment.toggleClass("is-active", isActive);
        $segment.attr("aria-pressed", isActive ? "true" : "false");
      });

      const $activeItem = $items.eq(nextIndex);
      const $activeHeader = $activeItem.find(".int-accordion__item-header");
      const $activePanel = $activeItem.find(".int-accordion__item-panel");
      const $activeIcon = $icons.filter("[data-index='" + nextIndex + "']");

      $activeItem.addClass("is-active");
      $activeHeader.attr("aria-expanded", "true");
      $activeIcon.addClass("is-active");
      updateCenterContent($activeItem, nextIndex, animate && nextIndex !== activeIndex);

      $panels.not($activePanel).slideUp(animationDuration, function () {
        $(this).attr("hidden", true);
      });

      $activePanel.removeAttr("hidden").hide().slideDown(animationDuration);
      activeIndex = nextIndex;
      currentRotation = rotation;
    };

    $headers.on("click", function () {
      const nextIndex = parseInt(
        $(this).closest(".int-accordion__item").attr("data-index"),
        10
      );

      if (!Number.isNaN(nextIndex)) {
        setActive(nextIndex);
      }
    });

    $icons.on("click", function () {
      const nextIndex = parseInt($(this).attr("data-index"), 10);

      if (!Number.isNaN(nextIndex)) {
        setActive(nextIndex);
      }
    });

    segmentGroups.forEach(($segment) => {
      if (!$segment || !$segment.length) {
        return;
      }

      $segment.on("mouseenter pointerenter focusin", function () {
        const hoverIndex = parseInt($(this).attr("data-index"), 10);

        if (!Number.isNaN(hoverIndex) && segmentGroups[hoverIndex]) {
          segmentGroups[hoverIndex].addClass("is-hovered");
        }
      });

      $segment.on("mouseleave pointerleave focusout", function () {
        const hoverIndex = parseInt($(this).attr("data-index"), 10);

        if (!Number.isNaN(hoverIndex) && segmentGroups[hoverIndex]) {
          segmentGroups[hoverIndex].removeClass("is-hovered");
        }
      });

      $segment.on("click", function () {
        const nextIndex = parseInt($(this).attr("data-index"), 10);

        if (!Number.isNaN(nextIndex)) {
          setActive(nextIndex);
        }
      });

      $segment.on("keydown", function (event) {
        if (event.key !== "Enter" && event.key !== " ") {
          return;
        }

        event.preventDefault();
        const nextIndex = parseInt($(this).attr("data-index"), 10);

        if (!Number.isNaN(nextIndex)) {
          setActive(nextIndex);
        }
      });
    });

    setActive(activeIndex, false);
  });
});
